/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. **/
import React from 'react'
import classNames from 'classnames'


class Icon extends React.PureComponent {
  render () {
    const { className, svgRef, ...otherProps } = this.props
    return (
      <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  
  <polygon points="9.226 0 5.001 4.23 .774 0 0 .766 4.23 4.999 0 9.234 .774 10 5.001 5.77 9.226 10 10 9.234 5.77 4.999 10 .766" className="icon-fill"/>
</svg>

    )
  }
}

Icon.displayName = 'CloseIcon'

export default Icon
